// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2xfYD","header":"ReportDetails_header__WebC9","title":"ReportDetails_title__2X9wm","left":"ReportDetails_left__3c55g"};